module.exports = __webpack_public_path__ + "img/中国文旅.2e844603.png";